// extracted by mini-css-extract-plugin
export default {"tooltip":"OP-z","arrow":"PP-z"};